import { SnackbarConstants } from '../constants/snackbar.constants';

export const SnackbarActions = (
    snackbarOpen,
    snackbarType = "success",
    snackbarMessage = "",
    snackbarVertical = "top",
    snackbarHorizontal =  "center"
) => ({
    type: SnackbarConstants.Set_SNACKBAR,
    snackbarOpen,
    snackbarType,
    snackbarMessage,
    snackbarVertical,
    snackbarHorizontal
});